import React, { useEffect, useRef, useState } from 'react';
import { Grid, Tooltip } from '@mui/material'
import { connect } from 'react-redux';
import * as menuActions from '../../store/actions/breadcrumb';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../style/common.css';
import * as Styled from '../../components/styled-components/Styled-Components';
import DefaultTable from '../../components/Table';
import TableCell from '@mui/material/TableCell';
import appConfig from "../../config/appConfig";
import SkeletonGridLoader from '../../components/SkeletonGridLoader';
import RemoveDialog from '../../components/RemoveDialog';
import { useLogout } from '../../components/Utils';
import * as businessUnitActions from '../../store/actions/businessUnit';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import DownloadIcon from '@mui/icons-material/Download';
import { useTranslation } from 'react-i18next';

const BusinessUnitDetail = ({setBreadcrumb, fetchBusinessUnitList, businessUnitDetails, deleteBusinessUnit, deleteBunit, getBUnitFilterDetails, bunitFilterList, exportReport}) => {
  const navigate = useNavigate();
  const isMounted = useRef(false);
  const { t } = useTranslation('common');

  const params = useLocation();
  const [removeDialogOpen, setRemoveDialogOpen] = useState(false)
  const onLogout = useLogout();

  const [pagination, setPagination] = useState({ limit: 10, offset: 1 });
  const [businessUnitFilter, setBusinessUnitFilter] = useState(params.state && params.state.dropdownSelected ? params.state.dropdownSelected : { key: 'All', value: "all" });
  const [filterList, setFilterList] = useState([]);
  const [selected, setSelected] = useState(null);
  const [sortValue, setSortValue] = useState({sortBy:"modifiedTime", sortOrder: "desc"});
  const [searchText, setSearchText] = useState("");
  const [selectedBusinessUnit,setSelectedBusinessUnit] = useState({});
  const [businessListDetails, SetBusinessListDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [tableDataObject, setTableDataObject]  = useState([]);
  const [isDataLoading , setIsDataLoading] = useState(false);

  const handleSearch = (search) => {
    isMounted.current = false;
    setSearchText(search);
  }

  const handleDialogOpen = (card) => {
    setRemoveDialogOpen(true);
  };
  const handleDialogClose = () => {
    setRemoveDialogOpen(false);
  };
  const onDeleteAction = () => {
    const data = {
      "businessUnitId":selectedBusinessUnit.businessUnitId,
      // "businessUnitLocationId": businessUnitFilter?.key === "All" ? null : selectedBusinessUnit.id
      "businessUnitLocationId": selectedBusinessUnit.id
    }
    setIsLoading(true);
    deleteBusinessUnit(data); 
  }

useEffect(() => {
  setBreadcrumb(t('Business Units & Locations'))
  if (params?.state && params?.state?.dropdownSelected) {
    setBusinessUnitFilter(params?.state?.dropdownSelected);
  }
}, [params]);
const handlePagination = (limit, offset) => {
  setIsDataLoading(true)
  const dataObject  = businessListDetails?.data &&
  businessListDetails?.data
                  .slice(
                    (limit) * (offset-1),
                    ( (limit) * (offset-1) + limit)
                  )
  setTableDataObject(dataObject)
  setIsDataLoading(false)
  setPagination({ limit, offset })
}

const getFilterValues = (filter) => {
  setPagination((prevState) => ({
    ...prevState,
    offset: 1
  }));
  setBusinessUnitFilter(filter);
}
useEffect(()=>{
  getBUnitFilterDetails();
},[])
useEffect(()=>{
  if(bunitFilterList && bunitFilterList?.status === 200){
    const all = [{value: 'all', key: 'All'}];
    const dataArr = bunitFilterList?.data || []
    const newArr = [...all, ...dataArr];
    const sortedArr = newArr.sort((a, b) => {
      if (a.key === 'All') return -1; // Ensure the object with 'All' comes first
      if (b.key === 'All') return 1;  // Ensure the object with 'All' comes first
      return a.key.localeCompare(b.key); // Sort other objects alphabetically by 'key'
    });
    setFilterList(sortedArr);
  } else if (bunitFilterList && bunitFilterList?.status === 401) {
    onLogout();
  }
},[bunitFilterList])

const filterValues = {
  "filterBy": businessUnitFilter?.key || null,
  "sortValue":sortValue
}

useEffect(() => {
  isMounted.current = true;
  fetchBusinessUnitList(pagination.limit, pagination.offset, searchText, filterValues);
}, [JSON.stringify(pagination), businessUnitFilter,JSON.stringify(sortValue)])

useEffect(() => {
  if (!isMounted.current) {
  setPagination({ limit: pagination.limit, offset: 1 })
  fetchBusinessUnitList(pagination.limit, pagination.offset, searchText, filterValues);
}
}, [searchText])

  useEffect(()=>{
      if(businessUnitDetails && businessUnitDetails.businessUnit && !businessUnitDetails.isError){
        const data = businessUnitDetails.businessUnit;
        if(pagination?.offset !== 0){
          const dataObject  = data &&
          data?.slice(
                            (pagination.limit) * (pagination.offset-1),
                            ( (pagination.limit) * (pagination.offset-1) + pagination.limit)
                          )
          setTableDataObject(dataObject)
        }

        SetBusinessListDetails({data: data})
      } else if(businessUnitDetails && businessUnitDetails.businessUnit && businessUnitDetails.businessUnit.status === 401) {
        // SetBusinessListDetails({data: []})
        onLogout();
      }
  },[businessUnitDetails])
  useEffect(()=> {
    if(deleteBunit && deleteBunit.status === 200) {
      setIsLoading(false);
      handleDialogClose();
      setPagination((prevState) => ({
        ...prevState,
        offset: 1
      }));
      const filterValue1 = {
        "filterBy": "All",
        "sortValue":sortValue
      }
      setBusinessUnitFilter( { key: 'All', value: "all" });
      fetchBusinessUnitList(pagination.limit, pagination.offset, searchText, filterValue1);
      getBUnitFilterDetails();
    } else if(deleteBunit && deleteBunit.status === 401) {
      onLogout();
    }
  },[deleteBunit])


const renderCells = (row) => {
  return <>
    <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16 }}>{row.businessUnitName}</TableCell>
    <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16 }}>{row.locationName ? row.locationName : "-"}</TableCell>
    <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16 }}>{row.address ? row.address : "-"}</TableCell>
    <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16, textTransform: 'uppercase', textAlign: 'right' }}>{row.currency ? row.currency : "-"}</TableCell>
  </>
}

const renderActionButton = (row) => {
  return <div className='display-flex' style={{gap: 10, display: 'flex'}}>
          <IconButton sx={{border:`1px solid ${appConfig.colors.darkblue}`, padding:'2px' }} onClick={() => {navigate('/view-businessunit/'+row?.businessUnitName,{ state: { businessUnit: row } })}}
              title={t('View')} aria-label="delete" size="small">
             <VisibilityIcon sx={{fontSize: 15, borderRadius:"50%", color:appConfig.colors.darkblue}} />
          </IconButton>
          <IconButton sx={{border:`1px solid ${appConfig.colors.darkblue}`, padding:'2px' }} onClick={() => {navigate('/edit-businessunit/'+row?.businessUnitName,{ state: { businessUnit: row } })}}
              title={t('Edit')} aria-label="delete" size="small">
             <EditIcon sx={{fontSize: 15, borderRadius:"50%", color:appConfig.colors.darkblue}} />
          </IconButton>
          {row.isDeletable === false ? (
            <Tooltip title={t("The business unit cannot be deleted because it is linked to the charitable activities")} arrow placement="top" style={{position: 'relative', cursor: 'default'}}>
            <IconButton sx={{border:`1px solid ${appConfig.colors.lightGray}`, padding:'2px' }} aria-label="delete" size="small">
                <DeleteIcon sx={{fontSize: 15, borderRadius:"50%", color:appConfig.colors.lightGray}} />
            </IconButton>
        </Tooltip>
            
          ) : 
          <IconButton sx={{border:`1px solid ${appConfig.colors.darkblue}`, padding:'2px' }} onClick={()=>{setSelectedBusinessUnit(row);handleDialogOpen(row)}}
          title={t('Delete')} aria-label="delete" size="small">
          <DeleteIcon sx={{fontSize: 15, borderRadius:"50%", color:appConfig.colors.darkblue}} />
        </IconButton>
          }
         
  </div>
}

const handleSort = (value) => {
  setSortValue(value)
}
// const filterValues1 = {
//   filterBy: filterData.channels.value,
//   fileId: filterData.files.map((f) => f.value).length > 0 ? filterData.files.map((f) => f.value) : "" ,
//   startDate: filterData.startDate.toISOString(),
//   endDate: filterData.endDate.toISOString()
// }


const handleExport = () => {
  exportReport(filterValues, tableDataObject)
}

  return (
    <div style={{paddingRight: 10}}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} xl={6} lg={6} md={6}>
          <h1 className='page-heading' ><b>{t("Business Units & Locations")}</b></h1>
        </Grid>
        <Grid item xs={12} sm={6} xl={6} lg={6} md={6} sx={{textAlign: {xs:"left", sm:"right", lg:"right", xl:"right",md:"right"}}}>
            <div>
              {/* <Styled.CancelButton
                variant="outlined"
                style={{marginRight: 10}}
                className="xs-bold"
                onClick={handleExport}
              >
                <DownloadIcon sx={{fontSize: 15, borderRadius:"50%", marginRight: '5px'}} /> Export
              </Styled.CancelButton> */}
              <Styled.PrimaryButton
                variant="contained"
                className="xs-bold"
                onClick={() => navigate('/create-businessunit', { state: { initState: true } })}
              >
                {t("Create")}
              </Styled.PrimaryButton>
            </div>
        </Grid>
      </Grid>
      <hr className='blue-border mb-30' />
      {removeDialogOpen && (
          <RemoveDialog 
          openDialog={removeDialogOpen}
          onClose={handleDialogClose}
          isLoading={isLoading}
          cardContent={t("This action will delete the selected Business Unit and associated Locations permanently Please confirm")}
          onSave={onDeleteAction}
          />
      )}
      { businessUnitDetails?.isLoading || isDataLoading ? <SkeletonGridLoader />
        :
      <DefaultTable
          title={t('Business Units & Locations')}
          handlePagination={handlePagination}
          headers={[{name: t('Business Unit Name'), sortEnabled:false},{name: t('Location Name'), sortEnabled:false},{name:t('Address'), sortEnabled:false},{name:t('Currency'), sortEnabled:false}]}
          // data={businessListDetails.data}
          data = {pagination.offset === 1 ? businessListDetails?.data?.slice(
            0,
            pagination.limit
          ) : tableDataObject}
          totalCount={businessListDetails?.data?.length}
          rightHeaderIndex={[3]}
          filterOptions={filterList}
          filterAction={(filter) => { getFilterValues(filter) }}
          isFilterEnabled
          // isSearchEnabled
          currentPage={pagination.offset}
          currentLimit={pagination.limit}
          defaultFilter={businessUnitFilter}
          selected={selected}
          renderCustomCells
          renderCells={renderCells}
          // searchKey={searchText}
          searchCallback={(text) => handleSearch(text)}
          searchPlaceholderText="Search by business unit name"
          hasAction 
          renderActionButton={renderActionButton}
          isSortEnabled
        />
  }
      </div>
  );
}

const mapStateToProps = (state) => ({ 
  businessUnitDetails: state.businessUnit.businessUnit,
  deleteBunit: state.businessUnit.deleteBunit,
  bunitFilterList: state.businessUnit.bunitFilterList
  })

const mapDispatchToProps = (dispatch) => {
    return {
        setBreadcrumb: (menu) => dispatch(menuActions.changeMenu(menu)),
        fetchBusinessUnitList: (limit, offset, search, filter) => dispatch(businessUnitActions.getBusinessUnitList(limit, offset, search, filter)),
        deleteBusinessUnit: (id) => dispatch(businessUnitActions.deleteBusinessUnit(id)),
        getBUnitFilterDetails: () => dispatch(businessUnitActions.getBUnitFilterDetails()),
        exportReport: (data,tableobj,searchText)=>dispatch(businessUnitActions.exportReport(data,tableobj, searchText))
    };
};
BusinessUnitDetail.propTypes = {
    setBreadcrumb: PropTypes.func.isRequired,
    fetchBusinessUnitList: PropTypes.func.isRequired,
    businessUnitDetails: PropTypes.object.isRequired,
    deleteBusinessUnit: PropTypes.func.isRequired,
    getBUnitFilterDetails: PropTypes.func.isRequired,
    exportReport:PropTypes.func.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(BusinessUnitDetail);

